import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import { FaCheck } from "react-icons/fa";
import { BiSolidCategory } from "react-icons/bi";
import './CheckboxFilters.css';

const cleanTextKey = (text) => {
    if (typeof text !== 'string') return text;
    return text
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9_]/g, '');
};

const Checkbox1 = (props) => {
    const { 
        infoSource,
        handleFilters,  
        filters = [],
        checked, 
        setCheked
    } = props;

    const handleToggle = (c, d) => () => {
        let a;
        let e;
        let f;

        checked.forEach((k, i) => {
            if (k.name === d) {
                return a = i;
            }
        });

        const b = [...checked];

        if (a !== undefined) {
            e = b[a].value.indexOf(c); 
            if (e === -1) {
                b[a].value.push(c);
            } else {
                b[a].value.splice(e, 1);
            }
            f = b[a].value;
        } else {
            b.push({ name: d, value: [c] });
            let g = b?.length - 1;
            f = b[g].value;
        }

        setCheked(b);
        handleFilters(f, `filterProduct.filter.${d}`); 
    };

    const checInputFil = (items, filterName) => {
        return items && items?.map((c, j) => {
            const itemId = `${c[0]}_${filterName}_${j}`;
            
            return (
                <li 
                    key={j} 
                    className="SideDrawer1-checkbox-item-modern"
                    style={{ animationDelay: `${j * 0.03}s` }}
                >
                    <input
                        onChange={handleToggle(c[0], filterName)}
                        type="checkbox"
                        id={itemId}
                        className="SideDrawer1-checkbox-input-modern check2"
                    />
                    <label 
                        className="SideDrawer1-checkbox-label-modern" 
                        htmlFor={itemId}
                    >
                        <span className="SideDrawer1-checkbox-box">
                            <FaCheck className="SideDrawer1-checkbox-icon" />
                        </span>
                        <span className="SideDrawer1-checkbox-text">{c[1]}</span>
                    </label>
                </li>
            );
        });
    };

    const FilChekboxForm = () => { 
        return filters && filters?.length > 0 && filters?.map((k, i) => { 
            let translFil = infoSource.getFilTranslate(k);
            let fil = k._id.name ? k._id : k;

            return (
                <Accordion.Item 
                    key={i} 
                    eventKey={i + 8486}
                    className="SideDrawer1-filter-item SideDrawer1-checkbox-filter-item"
                >
                    <Accordion.Header className="SideDrawer1-filter-header">
                        <BiSolidCategory className="SideDrawer1-filter-header-icon" />
                        <span className="SideDrawer1-filter-header-text">
                            {translFil.name}
                        </span>
                    </Accordion.Header>
                    <Accordion.Body className="SideDrawer1-filter-body SideDrawer1-checkbox-body">
                        <ul className="SideDrawer1-checkbox-list-modern">
                            {checInputFil(translFil.FilterItem, cleanTextKey(fil.name), fil)}
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>
            );
        });
    };

    return <>{FilChekboxForm()}</>;
};

export default Checkbox1;